module.exports = __webpack_public_path__ + "static/media/actuary-science.aaabe65b.webp";